import * as yup from "yup";

export const otpSchema = yup.object().shape({
  otp: yup
    .number()
    .min(6, "Otp must be at least of 6 letters")
    .typeError("OTP must be a number")
    .required("This field is required"),
});
